module.exports = __webpack_public_path__ + "img/gallery_layout2.ae06f2d7.png";